export default {
    cart: {
      account: '結算'
    },
    tips: {
      cart_success: "已成功加入購物車",
      add_success: "添加成功",
      empty: "空空如也~",
      order_success: "恭喜你，訂單提交成功",
      chose: "請選擇",
      un_pay_on_line: "暫不支持在線支付",
      area_not_empty: "地區不能為空",
      name_not_empty: "姓名不能為空",
      address_not_empty: "地址不能為空",
      phone_not_empty: "手機號不正確"
    },
    detail: {
      carriage: '運費',
      surplus: '剩餘',
      goods_detail: '商品詳情',
      cart: '購物車',
      add_cart: '加入購物車',
      CloseOrder:'完成訂單',
      mange:'管理',
      buy_now: '立即購買',
      Subtotal:'小計',
      Total:'合計',
      jian:'件',
      Delivery_method:'送貨方式',
      paypaly_method:'付款方法',
      paypaly1:'貨到付款',
      paypaly2:'支付',
      paypalyOut:'研發中，請耐心等待'
    },
    order: {
      freeFreight:'已免運費',
      allTotal:'商品總價',
      query:'訂單查詢',
      goods_info: '商品信息',
      pay_way: '选择送货及付款方式',
      offline: '貨到付款',
      online: '在線支付',
      pick_info: '送货资料',
      name_name: '姓名',
      name: '收件人姓名',
      phone_name: '電話',
      phone: '收件人手機號',
      area: '省、市、區等',
      region: '地區',
      address_name: '詳細地址',
      address: '街道門牌，樓層房間號等信息',
      offer_order: '提交訂單',
    },
    data: {
      Recipient_name:'收件人姓名',
      Recipient_nameTips:'请填写收件人的真实姓名，以确保顺利收到',
      Select_M:'選擇門市',
      email:"收件人郵箱",
      Select_M_number:'商店名稱',
      Selected_store_name:'選擇商店名稱',
      Shop_address:'店铺地址',
      address:'請選擇地址',
      Choose_payment_method:'选择的付款方式',
      default_address:'台湾',
    },
    indexdata:{
      index:'主頁',
      list:'列表',
      placeholder:'输入搜索关键字',
      Return:'返回'
    },
    Product_details_page: {
      guarantee:'保障',
      guarantee_texts: 'Genuine guarantee, fake one compensation, four fast refund',
      numbertext:'數量',
      Select_product_specification:'選擇產品規格',
      Package_selection: '套餐選擇',
      Buy_now: '立即購買'
    },
    newOrder:{
      Order_information:'訂單信息',
      Selection_of_delivery_and_payment_methods:'選擇送貨方式和付款方式',
      Delivery_place:'收貨地址',
      tw:'台灣',
      Delivery_method:'配送方式',
      Sub_total:'小計',
      Freight_charges:'貨物',
      Total:'總計',
      Go_to_checkout:'前往結算',
    },
    order3: {
      Total:'合計  HK$',
      Delivery_information:'送貨資料',
      Freight_charges:'貨物',
      change:'更改',
      Search_shop:'搜索門市',
      Order_notes:'訂單備注',
      Payment_information:'付款資料',
      Payment_method_selected:'已選擇的付款方式',
      Submit_order: '提交訂單',
      xxdz:'請輸入詳細地址',
      Select_address: '選擇地址',
      Tell_the_seller:'有什麼想告訴賣家嗎？',
      freight:"運費:",
      Spesifikasi_jualan_pendek:'該規格已售空',
    },
    index:{
      placeholder:'請輸入搜索關鍵詞',
      index:'首頁',
      list: '列表',
      language:'選擇語言'
    },
    Guarantee:{
      num:'數量',
      Pickup_method:'支持7-11、全家超商取貨',
      Guarantee:'品質保證',
      Freight:'免运费',
      Commodity_pic:'商品圖',
      Options:'選項',
      selected:'已選',
      Total_price:'訂單總價',
      Finally_cope:'最終應付',
      message:'留言',
      region:'Region',
      region_s:'District',
      country:'Country/Region'
    },
    Pay:{
      language:'货到付款',
      money:'HK$',
      to:'秒后跳转到首頁',
      postcode:'郵編',
      setMeal:'組合購買價',
      success:'下單成功!',
      time:'10分鐘内商家會自動確認您的訂單!',
      realMoney:'實付金額',
      orderNumber:'訂單編號',
      waitFor:'商家未發貨，請耐心等待'
    },
    comment:{
      comment:'發表評論',
      Praise:'好評',
      Average:'中評',
      Badreview:'差評',
      submitcomments:'提交評論',
      PleaseEnteraComment:'請輸入評論'
    },
    Toast:{
      inputName:'請输入名字',
      inputPhone:'請输入手机号',
      inputZip:'請输入邮编',
      inputAddress:'請輸入詳細地址',
      inputAlertAddress:'該地址不配送,請換其他地址',
    },
    contactUs:{
      callMe:'To learn more <br>,Pls contact the Messenger of our Facebook page!',
      afterShop:`Already shopping,Pls contact us: <br> Email: <a href='mailto:service325@hotmail.com'>service325@hotmail.com</a>`,
      confirm:'OK',
      shortSale:'該規格已售空',
    },
    ensure:{
      introduce:'商品介紹',
      Specifications:'商品規格',
      ensure:'商品保證',
      di:'第',
      commodity:'件商品'
    },
    wuliu:{
      orderSearch:'订单查询',
      provide:'本數據由物流官方提供',
      OrderOrLogistics:'訂單號/物流單號(填寫一項即可查詢)',
      orderPlaceho:'填寫相關訊息查詢',
      query:'查询订单号',
      Tips:'温馨提示',
      Tipsinfo:'收到商品後有任何疑問請聯繫在線客服或發郵件至service325@hotmail.com。同時請告知您的姓名/聯繫方式/訂單編號，我們會快速的給您及時處理，祝您購物愉快！',
    }
  }
  


// WEBPACK FOOTER //
// ./src/i18n/hk.js